import { apiReducer } from 'utils/API'
import { CONTACT } from '../constants'
import { USER_CLEAR } from 'modules/Login/constants'

export default apiReducer({
  entity: CONTACT,
  defaultData: [],
  resetActions: [USER_CLEAR],  
})
